import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy } from 'react';
const Dialog = lazy(() => import('@wayste/sour-ui').then((module) => ({ default: module.Dialog })));
const createContent = (quoteUrl, contactPhone, contactPhoneDisplay) => {
    const otherBody = (_jsxs("span", { children: ["Have a material that isn't in the guide? Not to worry we can still help you.", ' ', quoteUrl ? (_jsx("a", { href: quoteUrl, children: "Submit a free roll-off dumpster quote request online" })) : ('Submit a free roll-off dumpster quote request online'), ' ', "or give us a call at", ' ', contactPhone && contactPhoneDisplay ? _jsx("a", { href: `tel:${contactPhone}`, children: contactPhoneDisplay }) : 'our office', " and we'll be happy to help!"] }));
    return [
        {
            header: 'Construction & demolition',
            body: 'Any non hazardous material that you would find at a construction site or home renovation can go in. Ranging from sheet rock and lumber to shingles and concrete. Yard waste and other household trash can also be placed in the dumpster.\n\nIf you have a large amount of concrete or other heavy debris most of the time you will find it cheaper to get a second dumpster specifically for it.',
        },
        {
            header: 'Household items',
            body: "Whether you're moving or cleaning out your home most materials you have may go into the dumpster. Furniture and appliances can all go in.",
        },
        {
            header: 'Roofing',
            body: 'From asphalt or wood shingles to clay or slate it can all go in. Other material you may need to dispose of during a roofing job may go in as well.',
        },
        {
            header: 'Brush, branch & logs',
            body: 'Your typical yard waste can go into these dumpsters. Brushes, branches and leaves are all acceptable. If you have logs over 4 inches in diameter or tree stumps they can go in as well, however there is an additional charge for them.',
        },
        {
            header: 'Clean concrete',
            body: 'If you have a lot of concrete that is free of any rebar, trash, wire mesh or other contaminants this is the most cost effect dumpster for you.',
        },
        {
            header: 'Concrete with rebar',
            body: 'Concrete that has rebar, wire mesh or other metals found with typical concrete demolition.',
        },
        {
            header: 'Concrete, brick mix',
            body: 'Concrete that is mixed with, brick, stone or other heavy materials. With the exception of large amounts of dirt.',
        },
        {
            header: 'Asphalt',
            body: 'Have asphalt from ripping up a driveway, roadway, basketball court or other surface?',
        },
        {
            header: 'Other',
            body: otherBody,
        },
    ];
};
const MaterialGuide = ({ guideUrl, quoteUrl, contactPhone, contactPhoneDisplay, }) => {
    const content = createContent(quoteUrl, contactPhone, contactPhoneDisplay);
    return (_jsxs("div", { className: "flex flex-col gap-y-4 p-6", children: [_jsxs("div", { children: [_jsx("h2", { className: "text-4xl font-semibold", style: {
                            marginTop: 0,
                            marginBottom: 17,
                            textAlign: 'center',
                        }, children: "Material Selection Guide" }), _jsxs("p", { className: "", style: { textAlign: 'center', maxWidth: 525, margin: '0 auto' }, children: ["Don't know if a certain material is allowed in a dumpster? Check out our", ' ', guideUrl ? (_jsx("a", { className: "text-primary-400", href: guideUrl, children: "Guide for What Can and Can't Go Into a Dumpster" })) : ("Guide for What Can and Can't Go Into a Dumpster")] })] }), content.map((item) => (_jsxs("div", { style: { marginTop: 37 }, children: [_jsx("h3", { className: "text-2xl font-bold", style: { marginTop: 0, marginBottom: 10 }, children: item.header }), _jsx("p", { style: { margin: 0 }, children: item.body })] }, item.header)))] }));
};
export const MaterialGuideDialog = ({ open, onClose, quoteUrl, guideUrl, contactPhone, contactPhoneDisplay }) => {
    const isMobileLayout = window.innerWidth < 1024;
    return (_jsx(Dialog, { open: open, onClose: onClose, variant: isMobileLayout ? 'skinny-pullout' : undefined, className: "max-h max-h w-full xl:max-h-[75vh] xl:!max-w-[75vw]", showX: true, children: _jsx(MaterialGuide, { guideUrl: guideUrl, quoteUrl: quoteUrl, contactPhone: contactPhone, contactPhoneDisplay: contactPhoneDisplay }) }));
};
export default MaterialGuideDialog;
//# sourceMappingURL=MaterialGuideDialog.js.map